import React from 'react';
import { ArrowDropDownCircle } from '@material-ui/icons';
import FormConfigSelect from '../../config/FormConfigSelect';
import { FormSelectField } from '../../fields/FormSelectField';
export const FormSelectFieldPlugin = {
    icon: React.createElement(ArrowDropDownCircle, null),
    name: 'Dropdown',
    type: 'Select',
    dataTypes: ['text', 'integer', 'numeric', 'enum'],
    configurator: FormConfigSelect,
    element: FormSelectField
};
//# sourceMappingURL=FormSelectFieldPlugin.js.map